import React from 'react';

import {useGlobal} from '../../../../../api/hooks/useGlobal.hook';
import {TypographyVariantsEnum} from '../../../../../utils/_enums/typeography-variants.enum';
import {getLocaleEthPrice, getLocalePrice} from '../../../../../utils/_helper/locale-helper';
import {useAppSelector} from '../../../../../utils/_hooks/hooks';
import useEstimateGasFee from '../../../../../utils/_hooks/useEstimateGasFee.hook';
import {Typography} from '../../../typography/typography';
import styles from './transaction-fee-box.module.scss';

interface TransactionFeeBoxProps {
    gasUsage: number;
}

const TransactionFeeBox = (props: TransactionFeeBoxProps): JSX.Element => {
    const data = useGlobal();
    const ethereumPriceData = useAppSelector(
        (state) => state.blockchainSlice.ethereumPriceData
    );

    const estimatedGasFee = useEstimateGasFee(
        props.gasUsage,
        ethereumPriceData?.gasPrice
    );

    if (ethereumPriceData && estimatedGasFee) {
        return (
            <div className={styles['transaction-fee-box']}>
                <Typography
                    variant={TypographyVariantsEnum.CAPTION}
                    element={'span'}
                >
                    {data?.salesBox?.transactionFee ?? ''}
                </Typography>
                <Typography
                    variant={TypographyVariantsEnum.CAPTION}
                    element={'span'}
                >
                    {`~ ${getLocaleEthPrice(estimatedGasFee)}Ξ
                    (${getLocalePrice(estimatedGasFee * (1 / ethereumPriceData.exchangeRate))}€)`}
                </Typography>
            </div>
        );
    } else {
        return <div/>;
    }
};

export default TransactionFeeBox;
